import { FormItemProps } from "antd";
import dayjs from "dayjs";

export const datePickerGetValuePropsFormItem: FormItemProps["getValueProps"] = (
  value
) => {
  return { value: value ? dayjs(value) : "" };
};
